  <!-- NOTE - THE DATA BELOW (ENTIRE HTML) WAS GENERATED WITH SCRIPT (gen_store_hours) IN ROOT -->
<template>

  <v-card flat>
    <v-card-text>
      <v-form>

        <!-- DEPARTMENT sales -->
        <v-card flat>
          <v-card-title>Sales Hours</v-card-title>
          <v-container>

            <!-- DAY OF WEEK monday -->
            <v-row no-gutters>
              <!-- OPEN CLOSE -->

              <v-col cols="3" offset="1">
                <ampm-time-picker v-model="sales_monday_open" :label="'sales_monday_open' | titleize"
                  @change="updateModel('sales_monday_open', $event)" />
              </v-col>

              <v-col cols="3" offset="1">
                <ampm-time-picker v-model="sales_monday_close" :label="'sales_monday_close' | titleize"
                  @change="updateModel('sales_monday_close', $event)" />
              </v-col>

              <v-col cols="1">
                <v-btn @click="setClosed('sales_monday')" small color="secondary" class="mt-4">
                  <v-icon>mdi-door-closed-lock</v-icon>
                  Store Closed
                </v-btn>
              </v-col>
            </v-row>

            <!-- DAY OF WEEK tuesday -->
            <v-row no-gutters>
              <!-- OPEN CLOSE -->

              <v-col cols="3" offset="1">
                <ampm-time-picker v-model="sales_tuesday_open" :label="'sales_tuesday_open' | titleize"
                  @change="updateModel('sales_tuesday_open', $event)" />
              </v-col>

              <v-col cols="3" offset="1">
                <ampm-time-picker v-model="sales_tuesday_close" :label="'sales_tuesday_close' | titleize"
                  @change="updateModel('sales_tuesday_close', $event)" />
              </v-col>

              <v-col cols="1">
                <v-btn @click="setClosed('sales_tuesday')" small color="secondary" class="mt-4">
                  <v-icon>mdi-door-closed-lock</v-icon>
                  Store Closed
                </v-btn>
              </v-col>
            </v-row>

            <!-- DAY OF WEEK wednesday -->
            <v-row no-gutters>
              <!-- OPEN CLOSE -->

              <v-col cols="3" offset="1">
                <ampm-time-picker v-model="sales_wednesday_open" :label="'sales_wednesday_open' | titleize"
                  @change="updateModel('sales_wednesday_open', $event)" />
              </v-col>

              <v-col cols="3" offset="1">
                <ampm-time-picker v-model="sales_wednesday_close" :label="'sales_wednesday_close' | titleize"
                  @change="updateModel('sales_wednesday_close', $event)" />
              </v-col>

              <v-col cols="1">
                <v-btn @click="setClosed('sales_wednesday')" small color="secondary" class="mt-4">
                  <v-icon>mdi-door-closed-lock</v-icon>
                  Store Closed
                </v-btn>
              </v-col>
            </v-row>

            <!-- DAY OF WEEK thursday -->
            <v-row no-gutters>
              <!-- OPEN CLOSE -->

              <v-col cols="3" offset="1">
                <ampm-time-picker v-model="sales_thursday_open" :label="'sales_thursday_open' | titleize"
                  @change="updateModel('sales_thursday_open', $event)" />
              </v-col>

              <v-col cols="3" offset="1">
                <ampm-time-picker v-model="sales_thursday_close" :label="'sales_thursday_close' | titleize"
                  @change="updateModel('sales_thursday_close', $event)" />
              </v-col>

              <v-col cols="1">
                <v-btn @click="setClosed('sales_thursday')" small color="secondary" class="mt-4">
                  <v-icon>mdi-door-closed-lock</v-icon>
                  Store Closed
                </v-btn>
              </v-col>
            </v-row>

            <!-- DAY OF WEEK friday -->
            <v-row no-gutters>
              <!-- OPEN CLOSE -->

              <v-col cols="3" offset="1">
                <ampm-time-picker v-model="sales_friday_open" :label="'sales_friday_open' | titleize"
                  @change="updateModel('sales_friday_open', $event)" />
              </v-col>

              <v-col cols="3" offset="1">
                <ampm-time-picker v-model="sales_friday_close" :label="'sales_friday_close' | titleize"
                  @change="updateModel('sales_friday_close', $event)" />
              </v-col>

              <v-col cols="1">
                <v-btn @click="setClosed('sales_friday')" small color="secondary" class="mt-4">
                  <v-icon>mdi-door-closed-lock</v-icon>
                  Store Closed
                </v-btn>
              </v-col>
            </v-row>

            <!-- DAY OF WEEK saturday -->
            <v-row no-gutters>
              <!-- OPEN CLOSE -->

              <v-col cols="3" offset="1">
                <ampm-time-picker v-model="sales_saturday_open" :label="'sales_saturday_open' | titleize"
                  @change="updateModel('sales_saturday_open', $event)" />
              </v-col>

              <v-col cols="3" offset="1">
                <ampm-time-picker v-model="sales_saturday_close" :label="'sales_saturday_close' | titleize"
                  @change="updateModel('sales_saturday_close', $event)" />
              </v-col>

              <v-col cols="1">
                <v-btn @click="setClosed('sales_saturday')" small color="secondary" class="mt-4">
                  <v-icon>mdi-door-closed-lock</v-icon>
                  Store Closed
                </v-btn>
              </v-col>
            </v-row>

            <!-- DAY OF WEEK sunday -->
            <v-row no-gutters>
              <!-- OPEN CLOSE -->

              <v-col cols="3" offset="1">
                <ampm-time-picker v-model="sales_sunday_open" :label="'sales_sunday_open' | titleize"
                  @change="updateModel('sales_sunday_open', $event)" />
              </v-col>

              <v-col cols="3" offset="1">
                <ampm-time-picker v-model="sales_sunday_close" :label="'sales_sunday_close' | titleize"
                  @change="updateModel('sales_sunday_close', $event)" />
              </v-col>

              <v-col cols="1">
                <v-btn @click="setClosed('sales_sunday')" small color="secondary" class="mt-4">
                  <v-icon>mdi-door-closed-lock</v-icon>
                  Store Closed
                </v-btn>
              </v-col>
            </v-row>

          </v-container>
        </v-card>

        <!-- DEPARTMENT service -->
        <v-card flat>
          <v-card-title>Service Hours</v-card-title>
          <v-container>

            <!-- DAY OF WEEK monday -->
            <v-row no-gutters>
              <!-- OPEN CLOSE -->

              <v-col cols="3" offset="1">
                <ampm-time-picker v-model="service_monday_open" :label="'service_monday_open' | titleize"
                  @change="updateModel('service_monday_open', $event)" />
              </v-col>

              <v-col cols="3" offset="1">
                <ampm-time-picker v-model="service_monday_close" :label="'service_monday_close' | titleize"
                  @change="updateModel('service_monday_close', $event)" />
              </v-col>

              <v-col cols="1">
                <v-btn @click="setClosed('service_monday')" small color="secondary" class="mt-4">
                  <v-icon>mdi-door-closed-lock</v-icon>
                  Store Closed
                </v-btn>
              </v-col>
            </v-row>

            <!-- DAY OF WEEK tuesday -->
            <v-row no-gutters>
              <!-- OPEN CLOSE -->

              <v-col cols="3" offset="1">
                <ampm-time-picker v-model="service_tuesday_open" :label="'service_tuesday_open' | titleize"
                  @change="updateModel('service_tuesday_open', $event)" />
              </v-col>

              <v-col cols="3" offset="1">
                <ampm-time-picker v-model="service_tuesday_close" :label="'service_tuesday_close' | titleize"
                  @change="updateModel('service_tuesday_close', $event)" />
              </v-col>

              <v-col cols="1">
                <v-btn @click="setClosed('service_tuesday')" small color="secondary" class="mt-4">
                  <v-icon>mdi-door-closed-lock</v-icon>
                  Store Closed
                </v-btn>
              </v-col>
            </v-row>

            <!-- DAY OF WEEK wednesday -->
            <v-row no-gutters>
              <!-- OPEN CLOSE -->

              <v-col cols="3" offset="1">
                <ampm-time-picker v-model="service_wednesday_open" :label="'service_wednesday_open' | titleize"
                  @change="updateModel('service_wednesday_open', $event)" />
              </v-col>

              <v-col cols="3" offset="1">
                <ampm-time-picker v-model="service_wednesday_close" :label="'service_wednesday_close' | titleize"
                  @change="updateModel('service_wednesday_close', $event)" />
              </v-col>

              <v-col cols="1">
                <v-btn @click="setClosed('service_wednesday')" small color="secondary" class="mt-4">
                  <v-icon>mdi-door-closed-lock</v-icon>
                  Store Closed
                </v-btn>
              </v-col>
            </v-row>

            <!-- DAY OF WEEK thursday -->
            <v-row no-gutters>
              <!-- OPEN CLOSE -->

              <v-col cols="3" offset="1">
                <ampm-time-picker v-model="service_thursday_open" :label="'service_thursday_open' | titleize"
                  @change="updateModel('service_thursday_open', $event)" />
              </v-col>

              <v-col cols="3" offset="1">
                <ampm-time-picker v-model="service_thursday_close" :label="'service_thursday_close' | titleize"
                  @change="updateModel('service_thursday_close', $event)" />
              </v-col>

              <v-col cols="1">
                <v-btn @click="setClosed('service_thursday')" small color="secondary" class="mt-4">
                  <v-icon>mdi-door-closed-lock</v-icon>
                  Store Closed
                </v-btn>
              </v-col>
            </v-row>

            <!-- DAY OF WEEK friday -->
            <v-row no-gutters>
              <!-- OPEN CLOSE -->

              <v-col cols="3" offset="1">
                <ampm-time-picker v-model="service_friday_open" :label="'service_friday_open' | titleize"
                  @change="updateModel('service_friday_open', $event)" />
              </v-col>

              <v-col cols="3" offset="1">
                <ampm-time-picker v-model="service_friday_close" :label="'service_friday_close' | titleize"
                  @change="updateModel('service_friday_close', $event)" />
              </v-col>

              <v-col cols="1">
                <v-btn @click="setClosed('service_friday')" small color="secondary" class="mt-4">
                  <v-icon>mdi-door-closed-lock</v-icon>
                  Store Closed
                </v-btn>
              </v-col>
            </v-row>

            <!-- DAY OF WEEK saturday -->
            <v-row no-gutters>
              <!-- OPEN CLOSE -->

              <v-col cols="3" offset="1">
                <ampm-time-picker v-model="service_saturday_open" :label="'service_saturday_open' | titleize"
                  @change="updateModel('service_saturday_open', $event)" />
              </v-col>

              <v-col cols="3" offset="1">
                <ampm-time-picker v-model="service_saturday_close" :label="'service_saturday_close' | titleize"
                  @change="updateModel('service_saturday_close', $event)" />
              </v-col>

              <v-col cols="1">
                <v-btn @click="setClosed('service_saturday')" small color="secondary" class="mt-4">
                  <v-icon>mdi-door-closed-lock</v-icon>
                  Store Closed
                </v-btn>
              </v-col>
            </v-row>

            <!-- DAY OF WEEK sunday -->
            <v-row no-gutters>
              <!-- OPEN CLOSE -->

              <v-col cols="3" offset="1">
                <ampm-time-picker v-model="service_sunday_open" :label="'service_sunday_open' | titleize"
                  @change="updateModel('service_sunday_open', $event)" />
              </v-col>

              <v-col cols="3" offset="1">
                <ampm-time-picker v-model="service_sunday_close" :label="'service_sunday_close' | titleize"
                  @change="updateModel('service_sunday_close', $event)" />
              </v-col>

              <v-col cols="1">
                <v-btn @click="setClosed('service_sunday')" small color="secondary" class="mt-4">
                  <v-icon>mdi-door-closed-lock</v-icon>
                  Store Closed
                </v-btn>
              </v-col>
            </v-row>

          </v-container>
        </v-card>

        <!-- DEPARTMENT parts -->
        <v-card flat>
          <v-card-title>Parts Hours</v-card-title>
          <v-container>

            <!-- DAY OF WEEK monday -->
            <v-row no-gutters>
              <!-- OPEN CLOSE -->

              <v-col cols="3" offset="1">
                <ampm-time-picker v-model="parts_monday_open" :label="'parts_monday_open' | titleize"
                  @change="updateModel('parts_monday_open', $event)" />
              </v-col>

              <v-col cols="3" offset="1">
                <ampm-time-picker v-model="parts_monday_close" :label="'parts_monday_close' | titleize"
                  @change="updateModel('parts_monday_close', $event)" />
              </v-col>

              <v-col cols="1">
                <v-btn @click="setClosed('parts_monday')" small color="secondary" class="mt-4">
                  <v-icon>mdi-door-closed-lock</v-icon>
                  Store Closed
                </v-btn>
              </v-col>
            </v-row>

            <!-- DAY OF WEEK tuesday -->
            <v-row no-gutters>
              <!-- OPEN CLOSE -->

              <v-col cols="3" offset="1">
                <ampm-time-picker v-model="parts_tuesday_open" :label="'parts_tuesday_open' | titleize"
                  @change="updateModel('parts_tuesday_open', $event)" />
              </v-col>

              <v-col cols="3" offset="1">
                <ampm-time-picker v-model="parts_tuesday_close" :label="'parts_tuesday_close' | titleize"
                  @change="updateModel('parts_tuesday_close', $event)" />
              </v-col>

              <v-col cols="1">
                <v-btn @click="setClosed('parts_tuesday')" small color="secondary" class="mt-4">
                  <v-icon>mdi-door-closed-lock</v-icon>
                  Store Closed
                </v-btn>
              </v-col>
            </v-row>

            <!-- DAY OF WEEK wednesday -->
            <v-row no-gutters>
              <!-- OPEN CLOSE -->

              <v-col cols="3" offset="1">
                <ampm-time-picker v-model="parts_wednesday_open" :label="'parts_wednesday_open' | titleize"
                  @change="updateModel('parts_wednesday_open', $event)" />
              </v-col>

              <v-col cols="3" offset="1">
                <ampm-time-picker v-model="parts_wednesday_close" :label="'parts_wednesday_close' | titleize"
                  @change="updateModel('parts_wednesday_close', $event)" />
              </v-col>

              <v-col cols="1">
                <v-btn @click="setClosed('parts_wednesday')" small color="secondary" class="mt-4">
                  <v-icon>mdi-door-closed-lock</v-icon>
                  Store Closed
                </v-btn>
              </v-col>
            </v-row>

            <!-- DAY OF WEEK thursday -->
            <v-row no-gutters>
              <!-- OPEN CLOSE -->

              <v-col cols="3" offset="1">
                <ampm-time-picker v-model="parts_thursday_open" :label="'parts_thursday_open' | titleize"
                  @change="updateModel('parts_thursday_open', $event)" />
              </v-col>

              <v-col cols="3" offset="1">
                <ampm-time-picker v-model="parts_thursday_close" :label="'parts_thursday_close' | titleize"
                  @change="updateModel('parts_thursday_close', $event)" />
              </v-col>

              <v-col cols="1">
                <v-btn @click="setClosed('parts_thursday')" small color="secondary" class="mt-4">
                  <v-icon>mdi-door-closed-lock</v-icon>
                  Store Closed
                </v-btn>
              </v-col>
            </v-row>

            <!-- DAY OF WEEK friday -->
            <v-row no-gutters>
              <!-- OPEN CLOSE -->

              <v-col cols="3" offset="1">
                <ampm-time-picker v-model="parts_friday_open" :label="'parts_friday_open' | titleize"
                  @change="updateModel('parts_friday_open', $event)" />
              </v-col>

              <v-col cols="3" offset="1">
                <ampm-time-picker v-model="parts_friday_close" :label="'parts_friday_close' | titleize"
                  @change="updateModel('parts_friday_close', $event)" />
              </v-col>

              <v-col cols="1">
                <v-btn @click="setClosed('parts_friday')" small color="secondary" class="mt-4">
                  <v-icon>mdi-door-closed-lock</v-icon>
                  Store Closed
                </v-btn>
              </v-col>
            </v-row>

            <!-- DAY OF WEEK saturday -->
            <v-row no-gutters>
              <!-- OPEN CLOSE -->

              <v-col cols="3" offset="1">
                <ampm-time-picker v-model="parts_saturday_open" :label="'parts_saturday_open' | titleize"
                  @change="updateModel('parts_saturday_open', $event)" />
              </v-col>

              <v-col cols="3" offset="1">
                <ampm-time-picker v-model="parts_saturday_close" :label="'parts_saturday_close' | titleize"
                  @change="updateModel('parts_saturday_close', $event)" />
              </v-col>

              <v-col cols="1">
                <v-btn @click="setClosed('parts_saturday')" small color="secondary" class="mt-4">
                  <v-icon>mdi-door-closed-lock</v-icon>
                  Store Closed
                </v-btn>
              </v-col>
            </v-row>

            <!-- DAY OF WEEK sunday -->
            <v-row no-gutters>
              <!-- OPEN CLOSE -->

              <v-col cols="3" offset="1">
                <ampm-time-picker v-model="parts_sunday_open" :label="'parts_sunday_open' | titleize"
                  @change="updateModel('parts_sunday_open', $event)" />
              </v-col>

              <v-col cols="3" offset="1">
                <ampm-time-picker v-model="parts_sunday_close" :label="'parts_sunday_close' | titleize"
                  @change="updateModel('parts_sunday_close', $event)" />
              </v-col>

              <v-col cols="1">
                <v-btn @click="setClosed('parts_sunday')" small color="secondary" class="mt-4">
                  <v-icon>mdi-door-closed-lock</v-icon>
                  Store Closed
                </v-btn>
              </v-col>
            </v-row>

          </v-container>
        </v-card>

      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { AmPmTimePicker } from '@/components/inputs'
import { updated } from 'qrcode.vue'

const DEPARTMENTS = ['sales', 'service', 'parts']
const DAYS_OF_WEEK = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday']
const OPEN_CLOSE = ['open', 'close']

const allHours = () => {
  const hours = []
  DEPARTMENTS.forEach(department => {
    DAYS_OF_WEEK.forEach(dayName => {
      OPEN_CLOSE.forEach(oc => {
        hours.push(`${department}_${dayName}_${oc}`)
      })
    })
  })
  return hours
}

export default {
  name: 'rooftop-store-hours',
  components: {
    [AmPmTimePicker.name]: AmPmTimePicker
  },
  props: {
    value: {
      required: false,
      type: Object
    },
    rooftop: {
      required: false,
      type: Object,
      default: () => ({})
    },
    dealer: {
      required: false,
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    storeHours: function () {
      return allHours()
    },
    /*
     * BEGIN GENERATED - SEE gen_store_hours in root
     */
    sales_monday_open() { return this.value.store_hours['sales_monday_open'] },
    sales_monday_close() { return this.value.store_hours['sales_monday_close'] },
    sales_tuesday_open() { return this.value.store_hours['sales_tuesday_open'] },
    sales_tuesday_close() { return this.value.store_hours['sales_tuesday_close'] },
    sales_wednesday_open() { return this.value.store_hours['sales_wednesday_open'] },
    sales_wednesday_close() { return this.value.store_hours['sales_wednesday_close'] },
    sales_thursday_open() { return this.value.store_hours['sales_thursday_open'] },
    sales_thursday_close() { return this.value.store_hours['sales_thursday_close'] },
    sales_friday_open() { return this.value.store_hours['sales_friday_open'] },
    sales_friday_close() { return this.value.store_hours['sales_friday_close'] },
    sales_saturday_open() { return this.value.store_hours['sales_saturday_open'] },
    sales_saturday_close() { return this.value.store_hours['sales_saturday_close'] },
    sales_sunday_open() { return this.value.store_hours['sales_sunday_open'] },
    sales_sunday_close() { return this.value.store_hours['sales_sunday_close'] },
    service_monday_open() { return this.value.store_hours['service_monday_open'] },
    service_monday_close() { return this.value.store_hours['service_monday_close'] },
    service_tuesday_open() { return this.value.store_hours['service_tuesday_open'] },
    service_tuesday_close() { return this.value.store_hours['service_tuesday_close'] },
    service_wednesday_open() { return this.value.store_hours['service_wednesday_open'] },
    service_wednesday_close() { return this.value.store_hours['service_wednesday_close'] },
    service_thursday_open() { return this.value.store_hours['service_thursday_open'] },
    service_thursday_close() { return this.value.store_hours['service_thursday_close'] },
    service_friday_open() { return this.value.store_hours['service_friday_open'] },
    service_friday_close() { return this.value.store_hours['service_friday_close'] },
    service_saturday_open() { return this.value.store_hours['service_saturday_open'] },
    service_saturday_close() { return this.value.store_hours['service_saturday_close'] },
    service_sunday_open() { return this.value.store_hours['service_sunday_open'] },
    service_sunday_close() { return this.value.store_hours['service_sunday_close'] },
    parts_monday_open() { return this.value.store_hours['parts_monday_open'] },
    parts_monday_close() { return this.value.store_hours['parts_monday_close'] },
    parts_tuesday_open() { return this.value.store_hours['parts_tuesday_open'] },
    parts_tuesday_close() { return this.value.store_hours['parts_tuesday_close'] },
    parts_wednesday_open() { return this.value.store_hours['parts_wednesday_open'] },
    parts_wednesday_close() { return this.value.store_hours['parts_wednesday_close'] },
    parts_thursday_open() { return this.value.store_hours['parts_thursday_open'] },
    parts_thursday_close() { return this.value.store_hours['parts_thursday_close'] },
    parts_friday_open() { return this.value.store_hours['parts_friday_open'] },
    parts_friday_close() { return this.value.store_hours['parts_friday_close'] },
    parts_saturday_open() { return this.value.store_hours['parts_saturday_open'] },
    parts_saturday_close() { return this.value.store_hours['parts_saturday_close'] },
    parts_sunday_open() { return this.value.store_hours['parts_sunday_open'] },
    parts_sunday_close() { return this.value.store_hours['parts_sunday_close'] }
    /*
     * END GENERATED - SEE gen_store_hours in root
     */
  },
  data: function () {
    return {
      departments: DEPARTMENTS,
      daysOfWeek: DAYS_OF_WEEK,
      openClose: OPEN_CLOSE
    }
  },
  methods: {
    updateModel(key, value) {
      const updatedHours = { ...this.value.store_hours, [key]: value }
      const updatedModel = { ...this.value, store_hours: updatedHours }
      this.$emit('input', updatedModel)
    },
    // input is sales|service_<day_of_week>
    setClosed(type_day) {
      const updatedHours = { ...this.value.store_hours, [type_day + '_open']: null, [type_day + '_close']: null }
      const updatedModel = { ...this.value, store_hours: updatedHours }
      this.$emit('input', updatedModel)
    },

    copyStoreHours() {
      const defaultRt = this.dealer.rooftops.find(rt => rt.default_rooftop)
      if (defaultRt) {
        this.$emit('input', { ...this.value, store_hours: defaultRt.store_hours })
      }
    }
  }
}
</script>
